<template>
  <v-autocomplete
    :items="options"
    :value="value"
    :outlined="hasOutline"
    :dense="hasDense"
    :error-messages="errorMessages"
    :error="!!errorMessages.length"
    v-bind="$attrs"
    item-text="text"
    item-value="id"
    @change="onChange"
    v-on="$listeners"
  >
    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-autocomplete>
</template>

<script>
import { getDropdownOptions } from '@/api/FormService';

export default {
  name: 'DropdownSelect',
  inheritAttrs: false,
  props: {
    dropdownId: {
      type: [String, Array],
      default: '',
    },
    value: {
      type: [String, Array],
      default: '',
    },
    filterValues: {
      type: Array, default: () => [],
    },
    noOutline: {
      type: Boolean,
    },
    isDense: {
      type: Boolean,
    },
    filter: {
      type: Boolean,
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
    emitSelectedObject: {
      type: Boolean,
    },
  },
  data() {
    return { dropdownOptions: [] };
  },
  computed: {
    hasOutline() {
      return !this.noOutline;
    },
    hasDense() {
      return this.isDense;
    },
    options() {
      let values = this.filter ? [{ id: 'emptyValue', text: this.$t('empty') }] : [];
      values = values.concat([...this.dropdownOptions]);
      if (this.value) {
        if (Object.prototype.hasOwnProperty.call(this.$attrs, 'multiple')) {
          this.value.forEach((val) => {
            if (!values.find((element) => element.id === val)) {
              values.push({ id: val, text: val });
            }
          });
        } else if (!values.find((element) => element.id === this.value)) {
          values.push({ id: this.value, text: this.value });
        }
      }
      if (this.filterValues.length > 0) {
        return values.filter((opt) => this.filterValues.indexOf(opt.id) < 0);
      }
      return values;
    },
  },
  watch: {
    dropdownId: 'loadOptions',
  },
  activated() {
    this.loadOptions();
  },
  created() {
    this.loadOptions();
  },
  methods: {
    loadOptions() {
      getDropdownOptions(this.dropdownId, this.$i18n.locale)
        .then((dropdownOptions) => {
          this.dropdownOptions = dropdownOptions.length ? dropdownOptions.filter((item) => item.id !== '') : [];
        })
        .catch((err) => console.error(err));
    },
    onChange(val) {
      if (this.emitSelectedObject) {
        const selectedItem = this.options.find((opt) => opt.id === val);
        this.$emit('selectedItem', selectedItem);
      }
    },
  },
};
</script>
<style lang="css" scoped>

</style>
